import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cross-circle",
  "use": "icon-cross-circle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cross-circle\"><path d=\"M8 0c2.205 0 4.09.782 5.654 2.346S16 5.795 16 8s-.782 4.09-2.346 5.654S10.205 16 8 16s-4.09-.782-5.654-2.346S0 10.205 0 8s.782-4.09 2.346-5.654S5.795 0 8 0zm4 10.885L9.115 8 12 5.115 10.885 4 8 6.885 5.115 4 4 5.115 6.885 8 4 10.885 5.115 12 8 9.115 10.885 12 12 10.885z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol